import { render, staticRenderFns } from "./MultilateralDetail.vue?vue&type=template&id=797c6530&scoped=true"
import script from "./MultilateralDetail.vue?vue&type=script&lang=js"
export * from "./MultilateralDetail.vue?vue&type=script&lang=js"
import style0 from "./MultilateralDetail.vue?vue&type=style&index=0&id=797c6530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c6530",
  null
  
)

export default component.exports